<a mat-list-item (click)="toggle()">
    <div fxLayout="row" fxLayoutAlign="space-between stretch" [ngClass]="{'expandido': menuPrincipalService.expandido}">
        <div fxLayout="row" fxLayoutAlign="start stretch" matTooltip="Relatórios Gerenciais">
            <mat-icon>local_library</mat-icon>
            <span *ngIf="menuPrincipalService.expandido" class="nav-caption">Relatórios Gerenciais</span>
        </div>
        <div fxLayout="row" fxLayoutAlign="start stretch">
            <mat-icon *ngIf="menuPrincipalService.expandido" style="padding-top: 2px">{{getIcone()}}</mat-icon>
        </div>
    </div>
</a>
<mat-nav-list [ngClass]="{'expandido': menuPrincipalService.expandido}">

    <div [hidden]="!isMostrarSubMenu" [@menuState]="currentState">        
        
         <!-- RIM -->
         <sub-menu *ngIf="verificaAcesso(getModulos().RIM)" icone="print" titulo="RIM" rota="rim" toolTip="RIM"></sub-menu>

         <!-- Histórico do Beneficiário -->
         <sub-menu *ngIf="verificaAcesso(getModulos().RELATORIO_HISTORICO_BENEFICIARIO)" icone="play_for_work" titulo="Histórico do Beneficiário" rota="relhistbeneficiarios" toolTip="Histórico do Beneficiário"></sub-menu>

    </div>
</mat-nav-list>